import { HubFeature } from '@ats/api/cm';
import { LocDefs } from '@cm/core/localization';

export type CPCreqHistoryCESharedLocNames =
	| 'CPCReqHistoryCEDeleteButton'
	| 'CPCReqHistoryCEDeleteSuccess';
export const creqHistoryCELocs: LocDefs<CPCreqHistoryCESharedLocNames> = {
	CPCReqHistoryCEDeleteButton: {
		defaultValue: 'Delete',
		description: 'Label for the cert requirement delete button.',
		displayPath: 'History|Continuing Education|Delete',
		portal: 'CP',
		displayType: 'Button',
		feature: HubFeature.OtherRequirementUploadCandidateAccessDeleteItems,
		htmlAllowed: false,
		shared: false,
	},
	CPCReqHistoryCEDeleteSuccess: {
		defaultValue: 'Item deleted successfully.',
		description: 'Success message for deleting a CE Activity.',
		displayPath: 'History|Continuing Education|Delete Success',
		portal: 'CP',
		displayType: 'Content',
		feature: HubFeature.OtherRequirementUploadCandidateAccessDeleteItems,
		htmlAllowed: false,
		shared: false,
	},
};
